import React from 'react'
import HolidayCalendar from '../components/production/holidayCalendar/HolidayCalendar'

export default function HolidayCalendarPage() {
  return <HolidayCalendar />
}
